import type { ReactNode } from "react";
import { useHistory } from "react-router-dom";

import RetailerAccountMenu, {
  type RetailerAccountMenuItemKey,
} from "../../../components/shared/RetailerAccountMenu";

import { CART_ROUTE, SAVED_PRODUCTS_ROUTE } from "./routes";

type AccountDropdownRenderer = (close: () => void) => ReactNode;

/**
 * Account dropdown for every page of the "Saved Products & Cart" prototype.
 * Pass the result to `RetailerLayout`'s `accountDropdown` prop. "Saved
 * products" routes to the saved products page; "Orders" to the cart route;
 * other items just close the menu.
 */
export const useAccountDropdown = (): AccountDropdownRenderer => {
  const history = useHistory();

  return (close) => (
    <RetailerAccountMenu
      onItemClick={(itemKey: RetailerAccountMenuItemKey) => {
        close();
        if (itemKey === "saved-products") {
          history.push(SAVED_PRODUCTS_ROUTE);
        } else if (itemKey === "orders") {
          history.push(CART_ROUTE);
        }
      }}
    />
  );
};
